'use client';

import { useEffect, useState } from 'react';

import { SearchResultGRS } from '@/services/search/services/GRS.types';
import { useSearchContext } from '@/src/services/search/SearchProvider';
import { SearchResultLW } from '@/types/searchQuery';
import { AnnouncerModel } from '@nxt-costco-com/forge-components';

export function ResultsAnnouncer({
    announcerText,
}: {
    announcerText?: string;
}) {
    const { searchResult } = useSearchContext();
    const [ariaResultsText, setAriaResultsText] = useState<
        string | undefined
    >();

    const docsLength =
        (searchResult as SearchResultLW)?.docs?.length ||
        (searchResult as SearchResultGRS)?.searchResult?.results?.length;

    useEffect(() => {
        setAriaResultsText(announcerText);
    }, [docsLength, announcerText]);

    return (
        <AnnouncerModel
            announcerText={ariaResultsText}
            callback={setAriaResultsText}
            ariaLive="polite"
            announcerTime={5000}
        />
    );
}
